module.exports = __webpack_public_path__ + "static/img/more_heard4.b513001d.png";